<script>
import ListSubscriptionsComponent from '../../features/lists/ListSubscriptionsComponent';
import ModalSubscriptionView from '../modals/ModalSubscriptionView';
import ModalImportView from '../../../shared/views/ModalImportView';

export default {
  name: 'ListSubscriptionView',
  components: {
    'modal-subscription-view': ModalSubscriptionView,
    'modal-import': ModalImportView,
  },
  extends: ListSubscriptionsComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row :gutter="20" class="section-ctrl">
    <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" class="header-right">
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Inscripción
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Inscripciones
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              <!--<el-dropdown-item>
                <el-button size="small" class="btn-white">
                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Exportar PDF
                </el-button>
              </el-dropdown-item>-->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.subscriptionPlanFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Plan de Inscripción..."
                    :remote-method="onSearchSubscriptionPlans"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.subscriptionPlanFilter.id, 'SubscriptionPlanId')"
                  >
                    <el-option
                      v-for="item in subscriptionPlans"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.discountFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Descuento..."
                    :remote-method="onSearchDiscounts"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.discountFilter.id, 'DiscountId')"
                  >
                    <el-option
                      v-for="item in discounts"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="block">
                    <span class="block-title">F. Inscripción:</span>
                    <el-date-picker
                      v-model="filterOptions.subscriptionDate"
                      size="small"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="F. Inicio"
                      end-placeholder="F. Fin"
                      value-format="YYYY-MM-DD"
                      format="DD MMM YYYY"
                      @change="onRangeDate(filterOptions.subscriptionDate, 'SubscriptionDate', 'SubscriptionEndDate')"
                    />
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="block">
                    <span class="block-title">F. Conclusión:</span>
                    <el-date-picker
                      v-model="filterOptions.closuseDate"
                      size="small"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="F. Inicio"
                      end-placeholder="F. Fin"
                      value-format="YYYY-MM-DD"
                      format="DD MMM YYYY"
                      @change="onRangeDate(filterOptions.closuseDate, 'ClosuseDate', 'ClosuseEndDate')"
                    />
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
    </el-col>
    <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" class="header-left search-inputs-row">
      <el-input
        v-model="filterOptions.folioFilter"
        size="small"
        placeholder="Buscar folio..."
        suffix-icon="el-icon-search"
        @keyup.enter="onAllFilterChange(filterOptions.folioFilter, 'Folio')"
      />
      <el-input
        v-model="filterOptions.fullNameFilter"
        size="small"
        placeholder="Buscar estudiante..."
        suffix-icon="el-icon-search"
        @keyup.enter="onAllFilterChange(filterOptions.fullNameFilter, 'FullName')"
      />
      <el-input
        v-model="filterOptions.searchAmount"
        size="small"
        placeholder="Costo Total ($)..."
        suffix-icon="el-icon-search"
        @keyup.enter="onAllFilterChange(filterOptions.searchAmount, 'Amount')"
      />
    </el-col>    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label=""
        width="70"
      >
        <template #default="scope">
          <div>
            <el-avatar :src="mapProfileImage(scope.row.userProfile)" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="ESTUDIANTE"
        min-width="220"
      >
        <template #default="scope">
          <div>
            {{ scope.row.userProfile.firstName }} {{ scope.row.userProfile.lastName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="FOLIO"
        :width="100"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            {{ scope.row.folio }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="PLAN"
        :width="230"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            {{ scope.row.subscriptionPlan.name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="DESCUENTO"
        :width="230"
        align="center"
      >
        <template #default="scope">
          <div v-if="scope.row.discount">
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.discount.name }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="COSTO TOTAL"
        :width="120"
        align="center"
      >
        <template #default="scope">
          <div v-if="scope.row.subscriptionPlan">
            <el-tag
              type="info"
              effect="plain"
            >
              {{ formatMoney(scope.row.subscriptionPlan.amount) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="PAGO"
        :width="120"
        align="center"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              <i class="el-icon-money" /> {{ formatMoney(scope.row.amount) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="DESCUENTO %"
        :width="120"
        align="center"
      >
        <template #default="scope">
          <div v-if="scope.row.discount">
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.discount.amount }} <i class="uil uil-tag-alt" />
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subscriptionDate"
        label="F. INICIO"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.subscriptionDate) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="subscriptionEndDate"
        label="F. CONCLUSIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            v-if="onCheckUpdatedAt(scope.row.subscriptionEndDate)"
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.subscriptionEndDate) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="createdAt" label="CREACIÓN" :width="140" align="center">
        <template slot-scope="scope">
          <el-tag  type="info" effect="plain"><i class="el-icon-date"></i> {{ formatDate(scope.row.createdAt) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="ACTUALIZACIÓN" :width="140" align="center">
        <template slot-scope="scope">
          <el-tag v-if="onCheckUpdatedAt(scope.row.updatedAt)" type="info" effect="plain"><i class="el-icon-date"></i> {{ formatDate(scope.row.updatedAt) }}</el-tag>
        </template>
      </el-table-column>-->
      <el-table-column
        label="OPCIONES"
        :width="110"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-subscription-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>
